
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[apiKey]/inquiry",
      function () {
        return require("private-next-pages/[apiKey]/inquiry.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[apiKey]/inquiry"])
      });
    }
  